// extracted by mini-css-extract-plugin
export default {"main":"ErrorModal_main__J6HTS","error":"ErrorModal_error__q0Rzt","errorIcon":"ErrorModal_errorIcon__2CetZ"};